import React from "react";
import Chart from "./Chart/Chart";

export default function ExpensesChart(props) {
  const chartDataPoints = [
    { label: "Jan", value: 0 },
    { label: "Feb", value: 0 },
    { label: "Mar", value: 0 },
    { label: "Apr", value: 0 },
    { label: "May", value: 0 },
    { label: "Jun", value: 0 },
    { label: "Jul", value: 0 },
    { label: "Aug", value: 0 },
    { label: "Sep", value: 0 },
    { label: "Oct", value: 0 },
    { label: "Nov", value: 0 },
    { label: "Dec", value: 0 },
  ];

  for (let expense of props.expenses) {
    // ! for in loop is for object and for of loop is for array
    const expenseMonth = expense.date.getMonth(); //? starting from 0, 0 => Jan and 11 => Dec
    chartDataPoints[expenseMonth].value += expense.amount;
  }

  return (
    <div>
      <Chart dataPoints={chartDataPoints} />
    </div>
  );
}
